<template>
  <div class="vm-avatar-card">
    <avatar v-if="user" class="wh48" :user="user" :is_show_badge="is_show_badge">
      <div slot="doing" class="mt8">{{$t('c.AvatarCard.text1')}} {{user.creator.doing}}</div>
    </avatar>
    <template v-if="has_sponsor_info_detail">
      <div class="line mt16"></div>
      <template v-if="sponsor_info.in_detail && sponsor_info.in_detail.current_amount > 0">
        <div class="mt16 fsl12">{{$t('c.AvatarCard.text2')}}</div>
        <div class="flex-box flex-align-items-center mt8">
          <sponsor-in-out
            class="mr16"
            type="in"
            @click="open_sponsor_detail(user, 'in_detail')"
            :sponsor="sponsor_info.in_detail"
          ></sponsor-in-out>
          <span
            class="purple gl-hover-text-purple fs14"
            @click="open_sponsor_detail(user, 'in_detail')"
          >{{$t('c.AvatarCard.text3')}}</span>
        </div>
        <!--<div class="mt8">-->
        <!--<span class="fwb orange mr16">{{sponsor_info.in.plan.name}}</span>-->
        <!--<span class="black-3">(￥{{sponsor_info.in.plan.price}} / 月)</span>-->
        <!--</div>-->
      </template>
      <template v-if="sponsor_info.out_detail && sponsor_info.out_detail.current_amount > 0">
        <div class="mt16 fsl12">{{$t('c.AvatarCard.text4')}}</div>
        <!--<router-link :to="`/order/create?plan_id=${sponsor_info.out.plan.plan_id}`" class="mt8 block">-->
        <!--<span class="fwb purple mr16">{{sponsor_info.out.plan.name}}</span>-->
        <!--<span class="black-3">(￥{{sponsor_info.out.plan.price}} / 月)</span>-->
        <!--</router-link>-->
        <div class="flex-box flex-align-items-center mt8">
          <sponsor-in-out
            class="mr16"
            type="out"
            @click.native="open_sponsor_detail(user)"
            :sponsor="sponsor_info.out_detail"
          ></sponsor-in-out>
          <span class="purple gl-hover-text-purple fs14" @click="open_sponsor_detail(user)">{{$t('c.AvatarCard.text5')}}</span>
          <div class="line-vertical ml8 mr8"></div>
          <span @click="go_renew" class="purple fs14 pointer">{{$t('c.AvatarCard.text6')}}</span>
        </div>
      </template>
    </template>
    <template v-else>
      <router-link v-if="!is_hide_sponsor_btn" :to="{path:`/a/${user && user.url_slug}/plan`}">
        <btn class="mt24 size48">{{$t('c.AvatarCard.text7')}}</btn>
      </router-link>
    </template>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "avatar-card",
  props: {
    user: {
      type: Object,
      default() {
        return null;
      }
    },
    sponsor_info: {
      type: Object,
      default() {
        return null;
      }
    },
    is_hide_sponsor_btn: {
      type: Boolean,
      default() {
        return false;
      }
    },
    is_show_badge: {
      default: function() {
        return true;
      }
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapState("app", ["browser_size"]),
    has_sponsor_info_detail() {
      return (
        this.sponsor_info &&
        (this.sponsor_info.in_detail.current_amount > 0 ||
          this.sponsor_info.out_detail.current_amount > 0)
      );
    }
  },
  mounted() {},
  methods: {
    go_renew() {
      this.$emit("close");
      this.$mixin_router_push(`/a/${this.user.url_slug}/plan`);
    },
    open_sponsor_detail(user, type) {
      this.$emit("close");
      this.$modal.show(
        () => import("@/components/ModalPlan"),
        {
          user_id: user.user_id,
          type: type
        },
        {
          classes: "v--modal-plan v--modal",
          height: this.browser_size == "small" ? "100%" : "auto",
          width: this.browser_size == "small" ? "100%" : 640,
          adaptive: this.browser_size == "small" ? true : false
        }
      );
    }
  }
};
</script>

<style lang="stylus" scoped>
.vm-avatar-card{
  background-color: $white;
  border-radius: px2rem(4);
  border: 1px solid $black-1;
  width: 100%;
  padding: px2rem(24);
  box-sizing: border-box;

  .vm-avatar /deep/{
    .user-name {
      font-size: fs2rem(16);
    }
  }
}
</style>
